export const EMAILS_SET = "EMAILS_SET";
export const EMAILS_UPDATE = "EMAILS_UPDATE";
export const EMAILS_DELETE = "EMAILS_DELETE";
